import React, { useState, useEffect, useMemo, useCallback } from 'react';

import { Container } from './styles';

import { errorHandle, getPageParams, isScreenMobile } from '../../util/functions';

import { StateScreen } from '../constants';
import CrudHeader from '../../components/CrudHeader';
import LabelSp from '../../components/LabelSp';
import ButtonSp from '../../components/ButtonSp';
import InputTextSp from '../../components/InputTextSp';
import SenhaErpService from '../../services/SenhaErpService';

export default function BackupCliente(props) {
  // useSelectors
  const [senha, setSenha] = useState('');

  // useMemo
  const pageParams = useMemo(() => getPageParams(props.match.params, props.location.search), [
    props.location.search,
    props.match.params,
  ]);

  // useCallbacks
  const gerarSenha = useCallback(async () => {
    try {
      const retorno = await SenhaErpService.geraSenhaErp();
      setSenha(retorno.senha);
    } catch (err) {
      errorHandle(err);
    }
  }, []);

  // useEffect
  useEffect(() => {
    gerarSenha();
  }, [gerarSenha]);

  // functions
  function getTitle() {
    const titleDefault = 'Senha do ERP para hoje';
    let titleAdd = '';

    if (pageParams.stateScreen === StateScreen.stSearch) {
      titleAdd = '';
    }
    if (pageParams.stateScreen === StateScreen.stInsert) {
      titleAdd = '(Novo)';
    }
    if (pageParams.stateScreen === StateScreen.stUpdate) {
      titleAdd = `(Alterando Id: ${pageParams.idSelected})`;
    }
    if (pageParams.stateScreen === StateScreen.stView) {
      titleAdd = ` (Visualizando Id: ${pageParams.idSelected})`;
    }

    if (!isScreenMobile()) {
      return `${titleDefault} ${titleAdd}`;
    }

    return titleDefault;
  }

  // renders
  return (
    <Container className="container-page page-enter-tab">
      <div className="p-grid">
        <CrudHeader
          title={getTitle()}
          showButtonInsert={false}
          showButtonSearch={false}
          showButtonFilter={false}
        />
        {renderSearch()}
      </div>
    </Container>
  );

  function renderSearch() {
    return (
      <>
        <div className="p-col-12 p-md-3 p-lg-4 p-fluid">
          <LabelSp>Senha</LabelSp>
          <div className="p-inputgroup">
            <InputTextSp value={senha} disabled />
            <ButtonSp
              type="button"
              icon="pi pi-cog"
              className="p-button-secondary buttons"
              title="Buscar Cliente"
              onClick={() => gerarSenha()}
            />
          </div>
        </div>
      </>
    );
  }
}
